// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"WLnTYL","errorMessageContainer":"veiJ0I","errorMessage":"rSNHo6","errorIcon":"PzL7AI","visuallyHidden":"adduJu"};